import { createPortal } from "react-dom";
import { useLayoutEffect, useState, ReactNode } from "react";

export const ACTIONS_ID = "sing-page-header-actions";

interface PageHeaderActionsProps {
  children?: ReactNode;
}

/**
 * Portals page action links/buttons into the Sing page header
 * next to the page title.
 */
function PageHeaderActions({ children }: PageHeaderActionsProps) {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(() =>
    typeof document !== "undefined"
      ? document.getElementById(ACTIONS_ID)
      : null
  );

  useLayoutEffect(() => {
    const node = document.getElementById(ACTIONS_ID);
    if (node) {
      setMountNode(node);
      return undefined;
    }

    let tries = 0;
    const timer = window.setInterval(() => {
      const found = document.getElementById(ACTIONS_ID);
      tries += 1;
      if (found || tries > 40) {
        window.clearInterval(timer);
        if (found) setMountNode(found);
      }
    }, 25);

    return () => window.clearInterval(timer);
  }, []);

  if (!mountNode || children == null) return null;
  return createPortal(children, mountNode);
}

export default PageHeaderActions;
